module.exports = __webpack_public_path__ + "img/RAP2.eb07dd4e.png";